import { UserSwitchOutlined } from '@ant-design/icons';
import { Button } from '@mui/material';
import ConfirmationModal from 'components/modal/ConfirmationModal';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import UserService from 'services/nostradamus/administration/UserService';
import TokenService from 'services/authentication/TokenService';

export const impersonateAction = () => {
    return props => {
        const { component: MenuItem, onClick, params, ...restProps } = props;

        const { id, row } = params;
        const value = 'impersonate';
        const label = 'Impersonate';

        const { enqueueSnackbar } = useSnackbar();
        const [openModal, setOpenModal] = useState(false);

        const handleImpersonate = async () => {
            try {
                const { data } = await UserService.impersonate(id);
                // Clear current session
                TokenService.removeData();
                // Store the impersonated user's token
                TokenService.setData(data);
                // Hard reload to re-initialize app with new user context
                window.location.href = '/portal';
            } catch (err) {
                const msg =
                    err?.response?.data?.message || 'Failed to impersonate user';
                enqueueSnackbar(msg, { variant: 'error' });
            }
        };

        return (
            <>
                <ConfirmationModal
                    onClose={() => setOpenModal(false)}
                    isOpen={openModal}
                    title="Impersonate User"
                    renderActions={() => (
                        <>
                            <Button
                                onClick={() => setOpenModal(false)}
                                variant="outlined"
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleImpersonate}
                                color="primary"
                                variant="contained"
                            >
                                Impersonate
                            </Button>
                        </>
                    )}
                >
                    Are you sure you want to log in as{' '}
                    <strong>{row?.email || `user #${id}`}</strong>?
                </ConfirmationModal>
                <MenuItem
                    key={value}
                    value={value}
                    label={label}
                    icon={<UserSwitchOutlined />}
                    onClick={() => setOpenModal(true)}
                    {...restProps}
                >
                    {label}
                </MenuItem>
            </>
        );
    };
};
